import React, { useEffect, useState } from 'react';
import { Grid, Row, Col } from 'components/ui/grid';
import 'focus-within-polyfill';
import styled from 'styled-components';

import {
  FooterTitle,
  StyledHR,
  LinkLogo,
  StyledFooter,
  SubFooter,
  FooterLink,
} from './styles';
import Facebook from 'components/ui/icons/Logos/Facebook';
import Instagram from 'components/ui/icons/Logos/Instagram';
import LinkedIn from 'components/ui/icons/Logos/LinkedIn';
import TMPLogoFull from 'components/ui/icons/Logos/TMPLogoFull';
import Twitter from 'components/ui/icons/Logos/Twitter';
import {
  MARKETING_LINKS,
  TERMS_AND_CONDITIONS,
  COMMUNITY_LINKS,
  URLS,
} from 'consts';

// override Grid defaults
const ColPaddingBottom = styled(Col)`
  @media (min-width: 589px) and (max-width: 991px) {
    padding-bottom: 20px;
  }
`;

// override Grid defaults
const ColMarginRight = styled(Col)`
  margin-right: 2rem !important;
  @media (min-width: 589px) and (max-width: 991px) {
    margin-right: 0rem !important;
  }
`;

// override Grid defaults
const RowFooterWrapper = styled(Row)`
  display: flex;
  flex-wrap: nowrap;
  padding-right: 75px;
  @media (min-width: 1440px) {
    padding-left: 75px;
  }
  @media (max-width: 1240px) {
    flex-wrap: wrap;
    margin-left: 0px;
  }
`;

const Footer = () => {
  const [isHidden, setIsHidden] = useState(false);
  const currentYear = new Date().getFullYear();
  let location = window.location;

  const handleCookieSettingsToggle = () => {
    /* eslint-disable no-undef */
    if (typeof OneTrust !== 'undefined') {
      OneTrust.ToggleInfoDisplay();
    }
    /* eslint-enable */
  };

  useEffect(() => {
    // Prevent Footer from displaying within DTC
    // This was requested by the original designs
    if (
      location &&
      location.pathname &&
      location.pathname.indexOf('employer/clouds') > -1
    ) {
      setIsHidden(true);
    } else {
      setIsHidden(false);
    }
  }, [location, setIsHidden]);

  return (
    <>
      {isHidden ? null : (
        <>
          <StyledFooter className="bg-white">
            <Grid fluid={true} css="max-width: 1500px">
              <RowFooterWrapper>
                <Col className="mb-5" col={3} xs={12} md={6} lg={3}>
                  <LinkLogo href="/">
                    <TMPLogoFull />
                  </LinkLogo>
                </Col>
                <Col col={9} xs={12} md={12} lg={12}>
                  <Row className="d-flex flex-xl-nowrap">
                    <ColPaddingBottom col={5} md={5} lg={2}>
                      <FooterTitle>General</FooterTitle>
                      <ul className="list-unstyled text-nowrap">
                        <li>
                          <FooterLink href={URLS.helpCenter}>
                            Help Center
                          </FooterLink>
                        </li>
                        <li>
                          <FooterLink href={URLS.about}>About</FooterLink>
                        </li>
                        <li>
                          <FooterLink href={URLS.faq}>FAQs</FooterLink>
                        </li>
                        <li>
                          <FooterLink href={URLS.careers}>
                            Work At TMP
                          </FooterLink>
                        </li>
                        <li>
                          <FooterLink href={URLS.mediaKit}>
                            Media Kit
                          </FooterLink>
                        </li>
                        <li>
                          <FooterLink
                            target="_blank"
                            rel="noreferrer noopener nofollow"
                            href={MARKETING_LINKS.press}
                          >
                            Press
                          </FooterLink>
                        </li>
                        <li>
                          <FooterLink
                            target="_blank"
                            rel="noreferrer noopener nofollow"
                            href={TERMS_AND_CONDITIONS}
                          >
                            Terms of Service
                          </FooterLink>
                        </li>
                        <li>
                          <FooterLink
                            target="_blank"
                            rel="noreferrer noopener nofollow"
                            href={COMMUNITY_LINKS.privacyPolicy}
                          >
                            Privacy Policy
                          </FooterLink>
                        </li>
                        <li>
                          <FooterLink
                            role="button"
                            onClick={handleCookieSettingsToggle}
                          >
                            Cookie Settings
                          </FooterLink>
                        </li>
                      </ul>
                    </ColPaddingBottom>
                    <ColPaddingBottom
                      col={5}
                      md={5}
                      lg={2}
                      className="mr-md-6 text-nowrap"
                      style={{ marginRight: '4.5rem' }}
                    >
                      <FooterTitle>Careers and Community</FooterTitle>
                      <ul className="list-unstyled text-nowrap">
                        <li>
                          <FooterLink href={URLS.talentCommunity}>
                            Finding Work
                          </FooterLink>
                        </li>
                        <li>
                          <FooterLink href={MARKETING_LINKS.rallyProgram}>
                            Mentoring
                          </FooterLink>
                        </li>
                        <li>
                          <FooterLink href={MARKETING_LINKS.workRise}>
                            Upskilling
                          </FooterLink>
                        </li>
                        <li>
                          <FooterLink href={URLS.careerGuidance}>
                            Advice and Resources
                          </FooterLink>
                        </li>
                      </ul>
                    </ColPaddingBottom>
                    <ColMarginRight col={5} md={5} lg={2} className="mr-md-3">
                      <FooterTitle className="text-nowrap">
                        Small Companies
                      </FooterTitle>
                      <ul className="list-unstyled text-nowrap">
                        <li>
                          <FooterLink
                            target="_blank"
                            rel="noreferrer noopener nofollow"
                            href={URLS.howItWorksSMB}
                          >
                            How It Works
                          </FooterLink>
                        </li>
                        <li>
                          <FooterLink
                            target="_blank"
                            rel="noreferrer noopener nofollow"
                            href={URLS.pricing}
                          >
                            Pricing and Plans
                          </FooterLink>
                        </li>
                        <li>
                          <FooterLink
                            target="_blank"
                            rel="noreferrer noopener nofollow"
                            href={URLS.werkSpace}
                          >
                            Tips and Resources
                          </FooterLink>
                        </li>
                      </ul>
                    </ColMarginRight>
                    <Col
                      col={5}
                      md={5}
                      lg={2}
                      className="mr-md-3"
                      style={{ marginRight: '4.5rem' }}
                    >
                      <FooterTitle>Enterprise</FooterTitle>
                      <ul className="list-unstyled text-nowrap">
                        <li>
                          <FooterLink
                            target="_blank"
                            rel="noreferrer noopener nofollow"
                            href={URLS.howItWorksEnterprise}
                          >
                            How It Works
                          </FooterLink>
                        </li>
                        <li>
                          <FooterLink
                            target="_blank"
                            rel="noreferrer noopener nofollow"
                            href={URLS.pricing}
                          >
                            Pricing and Plans
                          </FooterLink>
                        </li>
                        <li>
                          <FooterLink
                            target="_blank"
                            rel="noreferrer noopener nofollow"
                            href={URLS.werklabsInsights}
                          >
                            WerkLabs Custom Insights
                          </FooterLink>
                        </li>
                        <li>
                          <FooterLink
                            target="_blank"
                            rel="noreferrer noopener nofollow"
                            href={URLS.werklabsLeadership}
                          >
                            DEI Thought Leadership
                          </FooterLink>
                        </li>
                        <li>
                          <FooterLink
                            target="_blank"
                            rel="noreferrer noopener nofollow"
                            href={URLS.werkSpace}
                          >
                            Tips and Resources
                          </FooterLink>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </Col>
              </RowFooterWrapper>
            </Grid>
          </StyledFooter>
          <StyledHR />
          <SubFooter>
            <div className="container-md overflow-visible pt-5">
              <div className="d-flex flex-row justify-content-center">
                <ul className="list-logos-updated-footer mt-3 mb-0 ml-0 pl-0">
                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={MARKETING_LINKS.facebook}
                    >
                      <Facebook />
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={MARKETING_LINKS.instagram}
                    >
                      <Instagram />
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={MARKETING_LINKS.twitter}
                    >
                      <Twitter />
                    </a>
                  </li>
                  <li>
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      href={MARKETING_LINKS.linkedin}
                    >
                      <LinkedIn />
                    </a>
                  </li>
                </ul>
              </div>
              <Row
                className="mt-2 text-dark justify-content-center"
                css={'gap:0.5rem'}
              >
                <div>&copy; {currentYear} The Mom Project</div>
                <div>All Rights Reserved</div>
              </Row>
            </div>
          </SubFooter>
        </>
      )}
    </>
  );
};

export default Footer;
